// Error class for the local-first BSB Bible data layer (M.3.6.3).
//
// Neutral module: imports nothing internal so any other file in the
// hierarchy (bsb-db, bsb-bootstrap, future picker / reader code) can
// import this without creating a cycle.

export type BibleHydrationErrorCode =
  | 'manifest_timeout'
  | 'manifest_fetch_failed'
  | 'manifest_parse_failed'
  | 'manifest_invalid'
  | 'manifest_unavailable_no_cache'
  | 'book_fetch_failed'
  | 'book_invalid'
  | 'idb_error';

interface BibleHydrationErrorOptions {
  cause?: unknown;
  context?: Record<string, unknown>;
  message?: string;
}

const DEFAULT_MESSAGES: Record<BibleHydrationErrorCode, string> = {
  manifest_timeout: 'Manifest fetch timed out.',
  manifest_fetch_failed: 'Manifest fetch failed.',
  manifest_parse_failed: 'Manifest JSON parse failed.',
  manifest_invalid: 'Manifest shape failed validation.',
  manifest_unavailable_no_cache:
    'Manifest fetch failed and no local cache is available.',
  book_fetch_failed: 'Book fetch failed.',
  book_invalid: 'Book shape failed validation.',
  idb_error: 'IndexedDB operation failed.',
};

export class BibleHydrationError extends Error {
  readonly code: BibleHydrationErrorCode;
  readonly context?: Record<string, unknown>;
  // `cause` is also a standard Error field on modern runtimes; we
  // duplicate it explicitly for older targets that may not surface it.
  readonly cause?: unknown;

  constructor(
    code: BibleHydrationErrorCode,
    options: BibleHydrationErrorOptions = {},
  ) {
    super(options.message ?? DEFAULT_MESSAGES[code]);
    this.name = 'BibleHydrationError';
    this.code = code;
    if (options.cause !== undefined) this.cause = options.cause;
    if (options.context !== undefined) this.context = options.context;
  }
}
